<template>
	<div id="app" v-wechat-title="this.$route.meta.title">
		<keep-alive>
			<router-view v-if='$route.meta.keepAlive'/>
		</keep-alive>
		<router-view v-if='!$route.meta.keepAlive'/>
	</div>
</template>
<script>
    
import wx from 'weixin-js-sdk';
import { Toast,Dialog} from 'vant';
import Qs from 'qs';
export default {
    name: 'app',
	components: {
		[Toast.name]: Toast,
        [Dialog.name]:Dialog
    },
	data() {
		return {
			query:Qs.parse(location.search.substring(1)),
            currentRoute:'',
            token:'',
            // titleName:''
		}
	},
	created(){
		this.initData();
	},
    mounted(){
        // this.init();
    },
	methods: {
		initData(){
            this.istoken();
		},
        istoken(){
                var _this = this;
            // if(localStorage.getItem('token')){
            //     var _this = this;
            //     let object = {
            //         url: 'd=wxapi&c=mp_auth&m=login',
            //         data: {
            //             token:localStorage.getItem('token')
            //         },
            //         target: 'wuliu',
                    
            //         success: res => {
            //             var result = res.data;
            //             localStorage.setItem('token',result.tokencode)
            //             localStorage.setItem('session',res.session_id)
                        
            //         },
            //         complete: res => {
            //             this.getConfig();
            //         }
            //     }
            //     this.$getData(object);
            // }
            let object = {
                url: 'd=wxapi&c=mp_auth&m=login',
                data: {
                    // "mobile":'17700004003', //速讯
                    // "mobile":'17700004004', //货满满
                    // "mobile":'17700004005', //川海 未有数据
                    // "mobile":'17700009911', //智连优达 未有数据
                    // "mobile":'17700007001', //鑫业兴  未有数据
                    // "mobile":'17700007002', //鲸喜 未接入车辆数据
                    // "mobile":'17700007004', //瑞锋建材智慧物流 未有数据
                    // "mobile":'17700007005', //新疆京泓智慧物流
                    // "mobile":'17700007006', //顺途
                    // "mobile":'17700007007', //鑫湘茂
                    // "mobile":'17700007008', //高兵
                    // "mobile":'17700007009', //中通氢电
                    // "mobile":'17700007010', //中通氢电
                    // "mobile":'17700007011', //浙江绿途
                    "mobile":'17700007013', //聚宏物流
                    // "mobile":"17700009941",  //陕煤集团零碳智慧物流运营平台  
                    // "password":'tgj3199',
                    "password":'123456',
                },
                target: 'wuliu',
                ismessage:true,
                success: res => {
                    var result = res.data;
                    // localStorage.setItem('token',result.tokencode)
                    // localStorage.setItem('session',res.session_id)
                },
                login:res=>{
                    // localStorage.setItem('token','')
                    // localStorage.setItem('session','')
                },
                complete: res => {
                    _this.getConfig();
                }
            }
            this.$getData(object);
        },
        getConfig(){
            var _this=this;
            let obj={
                url:'d=wxapi&c=open_config&m=get_config',
                data:{},
                target:'wuliu',
                success:res=>{
                    var result=res.data;
                    _this.$store.dispatch('set_configdata', result);
                },
            }
            this.$getData(obj);
        }
    },
    watch: {
        '$route' () {
			let obj = this.$router.currentRoute.meta;
            // this.currentRoute=this.$router.currentRoute;
            // this.token=this.$router.currentRoute.query.token;
            // if(this.$store.state.shopdata){
            //     this.getshare();
            // }
            // if(localStorage.getItem('token')){
            //     this.$cookie.set('ci_session', localStorage.getItem('token'));
            // }
            
		}
	},
}
</script>